import PropTypes from 'prop-types';
import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import { withRouter } from 'react-router-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faBars, faHome, faUser as fasUser, faUsers, faStar, faEnvelope as fasEnvelope, faCog,
    faQuestion, faUserCircle, faMapMarkerAlt, faCalendarAlt as fasCalendarAlt, faPencilAlt, faShare,
    faPlus, faAngleRight, faUpload, faLayerGroup, faShareAlt, faUserTie, faTrophy, faEyeSlash,
    faHourglassHalf, faSignOutAlt, faTag, faKey, faEquals, faUserCheck, faClock, faTimes, faTrashAlt,
    faClipboardList, faPaperclip, faSearch, faFileSignature, faClipboardCheck, faCalendarDay, faClipboard,
    faLock, faTasks, faStamp, faPaperPlane, faAngleDoubleUp, faFire, faTv, faAngleDown,
    faHandshake, faEllipsisH, faChartLine, faQuestionCircle, faLink, faAngleLeft, faInfoCircle, faSignature,
    faArrowLeft, faArrowRight, faUserPlus, faBullhorn, faBolt, faCheck, faUserFriends,
    faRss, faUniversity, faTimesCircle, faCheckCircle, faBell, faEdit, faPlusCircle,
    faChevronDown, faImage, faDownload, faEllipsisV
} from '@fortawesome/free-solid-svg-icons';
import {
    faCalendar, faEnvelope as farEnvelope, faUser as farUser, faCheckCircle as farCheckCircle,
    faCalendarAlt as farCalendarAlt, faThumbsUp, faComment, faHourglass as farHourglass, faEdit as farEdit,
    faArrowAltCircleRight as farArrowAltCircleRight, faCommentDots as farCommentDots
} from '@fortawesome/free-regular-svg-icons';
import { faYoutube, faTwitter } from '@fortawesome/free-brands-svg-icons';
import Spinner from 'components/Spinner/Spinner';
import { handleAutoLogin } from 'redux/modules/authentication';
import AlertNotifier from 'components/AlertNotifier/AlertNotifier';
import ModalNotifyPwa from 'components/ModalNotifyPwa/ModalNotifyPwa';
import moment from 'moment';
import AppRouteError from 'containers/App/components/RouteError/AppRouteError';
import AppRouter from 'containers/App/components/Router/AppRouter';
import AppNav from 'containers/App/components/Nav/AppNav';
import Head from 'components/Head/Head';
import { setIsPWA } from 'utils/helpers';
import { ROUTE_PATHS_NAV_NORENDER, ROUTE_PATHS } from 'config/constants';
import { MOMENT_LOCALE } from 'config/locales';
import 'styles/style.css';

// add fa icons to use in the app
library.add([
    faBars, faHome, fasUser, farUser, faUsers, faStar, fasEnvelope, farEnvelope, faCog,
    faQuestion, faUserCircle, faMapMarkerAlt, fasCalendarAlt, farCalendarAlt, faPencilAlt,
    faShare, faPlus, faAngleRight, faUpload, faCalendar, faLayerGroup, farCheckCircle, faShareAlt,
    faUserTie, faTrophy, faEyeSlash, faHourglassHalf, faYoutube, faTwitter, faSignOutAlt, faThumbsUp,
    faComment, faTag, faTimes, faKey, faClock, faEquals, faUserCheck, faTrashAlt, faClipboardList,
    faPaperclip, faSearch, faFileSignature, faClipboardCheck, faCalendarDay, faClipboard, faLock,
    faTasks, faStamp, faPaperPlane, faAngleDoubleUp, faTimesCircle, faCheckCircle,
    faFire, faTv, faAngleDown, faHandshake, faEllipsisH, faChartLine, faQuestionCircle, faLink,
    faAngleLeft, faInfoCircle, faSignature, faArrowLeft, faArrowRight, faUserPlus, faPlusCircle,
    faBullhorn, faBolt, faCheck, faUserFriends, faRss, faUniversity, faBell, faEdit, farHourglass,
    faChevronDown, farEdit, faImage, faDownload, farArrowAltCircleRight, farCommentDots, faEllipsisV
]);

// set the french locale to moment
moment.locale('fr', MOMENT_LOCALE);

class AppContainer extends Component {
    static propTypes = {
        location: PropTypes.object.isRequired,
        handleAutoLogin: PropTypes.func.isRequired,
        isAppReady: PropTypes.bool.isRequired,
        isAuthed: PropTypes.bool.isRequired
    }

    constructor(props) {
        super(props);

        const { location } = props;

        // see public/manifest.json "start_url"
        if (location.search.indexOf('source=pwa') > -1) {
            setIsPWA();
        }
    }

    componentDidMount() {
        this.props.handleAutoLogin(this.props.location);
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.location !== nextProps.location
            || this.props.isAppReady !== nextProps.isAppReady
                || this.props.isAuthed !== nextProps.isAuthed) {
            return true;
        }

        return false;
    }

    render() {
        const { isAppReady, isAuthed, location } = this.props;
        const { pathname } = location;

        if (isAppReady) {
            const IS_RENDER_NAV = ROUTE_PATHS_NAV_NORENDER.indexOf(pathname) === -1 &&
                pathname.indexOf(ROUTE_PATHS.CAMPAIGN_IFRAME('')) === -1;
            const IS_RENDER_NOTIFY_PWA = pathname.indexOf(ROUTE_PATHS.CAMPAIGN_IFRAME('')) === -1;

            return (
                <React.Fragment>
                    <div
                        id='outer-container'
                        className={IS_RENDER_NAV ? 'outer-container-withnav' : ''}>
                        <Head pathname={pathname} />

                        {IS_RENDER_NAV && (
                            <AppNav location={location} />
                        )}

                        <AppRouteError location={location}>
                            <AppRouter isAuthed={isAuthed} />
                        </AppRouteError>
                    </div>

                    <AlertNotifier />

                    {IS_RENDER_NOTIFY_PWA && (
                        <ModalNotifyPwa />
                    )}
                </React.Fragment>
            );
        }

        return (
            <main className='page-wrap'>
                <div className='loading-container'>
                    <Spinner />
                </div>
            </main>
        );
    }
}

function mapStateToProps({ authentication }) {
    return {
        isAppReady: authentication.isAppReady,
        isAuthed: authentication.isAuthed
    };
}

function mapDispatchToProps(dispatch) {
    return {
        handleAutoLogin: (location) => {
            dispatch(handleAutoLogin(location));
        }
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(AppContainer)
);
